module.exports = __webpack_public_path__ + "img/error-warning.14da3b69.svg";